
import { mapActions, mapGetters } from 'vuex';
import StarIcon from '~/components/ui/icons/StarIcon.vue';
import MarketIcon from '~/components/ui/icons/MarketIcon.vue';
import SettingsIcon from '~/components/ui/icons/SettingsIcon.vue';
import SkadeLogoWithText from '~/assets/icons/skade-logo-with-text.svg';
import UserImgInfo from '@/components/ui/molecule/UserImgInfo';
import { appURLs, inAppRedirect } from '@/utils/route-redirects';
import 'swiped-events/dist/swiped-events.min.js';
import { capitalizeFirstLetter } from '@/utils/string-formatter';
import { eventManager } from '@/utils/behavior/applicationEvents/event-manager';
import TrophyIcon from '~/components/ui/icons/TrophyIcon.vue';
import MessageIcon from '~/components/ui/icons/MessageIcon.vue';

export default {
  name: 'MobileSidebar',
  components: {
    StarIcon,
    MarketIcon,
    SettingsIcon,
    SkadeLogoWithText,
    UserImgInfo,
    TrophyIcon,
    MessageIcon,
  },
  computed: {
    ...mapGetters('authentication', ['profile']),
    ...mapGetters('messaging', ['messageNotificationCount']),
    sanitizedNotificationCount() {
      return this.messageNotificationCount ?? 0;
    },
    appURLs() {
      return appURLs;
    },
  },
  mounted() {
    const sidebarContainer = document.getElementById(
      'mobile-sidebar__container'
    );

    sidebarContainer.addEventListener('swiped-left', () => {
      this.handleCloseSidebar();
      eventManager.raiseToggleMenuBurgerEvent({ state: 'Closed' });
    });

    this.toggleSideBarAnimation();
    // document.body.style.overflow = 'hidden';
  },
  methods: {
    ...mapActions('profile', ['setContentStep']),
    handleCloseSidebar() {
      this.toggleSideBarAnimation();

      // Waiting for CSS animation to finish
      setTimeout(() => {
        this.$emit('onCloseSidebar');
      }, 200); // match CSS transition duration
    },
    handleBackdropClick() {
      this.handleCloseSidebar();
      eventManager.raiseToggleMenuBurgerEvent({ state: 'Closed' });
    },
    goToProfile(profileId) {
      console.info('Navigating to profile');
      // Sending event to GTM
      eventManager.raiseClickMenuPrincipalEvent({
        text: 'MobileSidebar | Profile',
      });
      this.handleCloseSidebar();
      // Waiting for CSS animation to finish
      setTimeout(() => {
        inAppRedirect(appURLs.profileById(profileId));
      }, 200);
    },
    toggleSideBarAnimation() {
      const sidebarContainer = document.getElementById(
        'mobile-sidebar__container'
      );
      const sidebarBackdrop = document.getElementById(
        'mobile-sidebar__backdrop'
      );

      // Without timeout, browser (at lease chrome) skips the animation
      setTimeout(() => {
        sidebarContainer.classList.toggle('visible');
        sidebarBackdrop.classList.toggle('visible');
      }, 0);
    },
    handleLinkClick(path, value) {
      // Sending event to GTM
      eventManager.raiseClickMenuPrincipalEvent({
        text: 'MobileSidebar | ' + capitalizeFirstLetter(value),
      });
      this.toggleSideBarAnimation();
      // Waiting for CSS animation to finish
      setTimeout(() => {
        this.$emit('onCloseSidebar');
        this.$router.push(path);
      }, 200); // match CSS transition duration
    },

    // Write a function that puts the first letter of a string as capital
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
